var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNotch180(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.165,
    height: 81.989,
    viewBox: "0 0 83.165 81.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-circle-notch",
    "data-name": "Icon awesome-circle-notch",
    d: "M47.51,5.087V7.88a4.026,4.026,0,0,0,2.965,3.868,30.851,30.851,0,1,1-16.662,0A4.026,4.026,0,0,0,36.779,7.88V5.089a4.027,4.027,0,0,0-5.038-3.9,41.582,41.582,0,1,0,20.764-.011A4.017,4.017,0,0,0,47.51,5.087Z",
    transform: "translate(83.727 83.045) rotate(180)",
    fill: "#faa378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNotch180);
export default __webpack_public_path__ + "static/media/icon-circle-notch180.b24fea908cf17d7a01f95ff4c5203c58.svg";
export { ForwardRef as ReactComponent };